import { useState, useEffect } from 'react';

const useImageExists = (src, fallback) => {
  const [imgSrc, setImgSrc] = useState(src);

  useEffect(() => {
    if (!src) {
      setImgSrc(fallback);
      return;
    }

    const img = new Image();
    img.src = src;

    img.onload = () => setImgSrc(src);
    img.onerror = () => setImgSrc(fallback);
  }, [src, fallback]);

  return imgSrc;
};

export default useImageExists;
